<template>
  <div style="overflow:hidden">
    <div class="header image-center">
      <Nav :message="scroll" @data="dataInfo"></Nav>
    </div>
    <div class="content" style="margin-top:130px">
      <div class="thumb">
        <i class="iconfont iconhome"></i>
        <span>主页</span>
        <i class="iconfont iconyou"></i>
        <span>关于我们</span>
        <i class="iconfont iconyou"></i>
        <span>合作伙伴</span>
      </div>
      <div class="row tab-block">
        <div v-for="(item, index) in tabs" :key="index" :class="{focus:focusIndex==index}">
          <router-link :to="'/about_us?tab='+index" @click="tabShow(index)">{{item.text}}</router-link>
        </div>
      </div>
      <!-- 公司简介 -->
      <div class="row company-profile" style="padding-top:10px;" v-show="focusIndex===0">
        <div class="row-title">
          <div class="profile-text">
            <p>陕西零工保信息科技有限公司是植根于新经济领域内，具备领先科技的数字服务化供应商。公司的核心业务以帮助业态内传统企业战略规划与数字化升级为主，涉及企业财税管理、灵活用工解决方案提供、人力资源规划与培训、企业品牌塑造及数字化营销、业态与政策研究和行业标准制定等。旨在以数字新经济变革的视角来探寻行业发展方向，为新经济领域的企业赋能，为国家经济在后互联网时代的新旧动能转化助力。</p>
            <p>“全球云端”零工创客共享服务平台，运用人工智能、区块链、大数据和云计算等尖端互联网技术，着力创建以放薪管家、金创客、零工云服、财税服务、企业增值服务为一体的生态服务体系，旨在为自由职业者创收、提升自由职业者服务能力、为企业优化人力资源结构、降低企业经营风险、为企业和劳动者双方精细化供需匹配等问题提供解决方案，真正做到为企业灵活用工和自由职业者就业提供一个值得信赖的全面保障系统。</p>
          </div>
          <div class="profile-img">
            <div style="display:flex">
              <div>
                <img src="../../public/images/about/profile1.jpg" />
              </div>
              <div>
                <img src="../../public/images/about/profile2.jpg" />
              </div>
            </div>
            <div>
              <img src="../../public/images/about/profile3.jpg" />
            </div>
            <!-- <div style="margin-top:10px">
              <img src="../../public/images/about/profile4.jpg" />
            </div>-->
          </div>
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="row corporate-culture" v-show="focusIndex===1">
        <div class="content">
          <div class="row">
            <div
              class="list-item1"
              style="background-image:url(https://file.lgbfss.com/www/official/images/about/culture1.jpg);"
            >
              <div class="cover-layer">
                <div style="padding-top:60px;padding-bottom:0px">
                  <div class="item-icon item-icon1"></div>
                </div>
                <p class="p-title">使命</p>
                <p class="p-text">为客户解决问题</p>
                <p class="p-text">为社会创造价值</p>
              </div>
            </div>
            <div
              class="list-item1"
              style="background-image:url(https://file.lgbfss.com/www/official/images/about/culture2.jpg);"
            >
              <div class="cover-layer">
                <div style="padding-top:60px;padding-bottom:0px">
                  <div class="item-icon item-icon2"></div>
                </div>
                <p class="p-title">愿景</p>
                <p class="p-text">成为新经济领域</p>
                <p class="p-text">领先的数字化服务供应商</p>
              </div>
            </div>
            <div
              class="list-item1"
              style="background-image:url(https://file.lgbfss.com/www/official/images/about/culture3.jpg);"
            >
              <div class="cover-layer">
                <div style="padding-top:60px;padding-bottom:0px">
                  <div class="item-icon item-icon3"></div>
                </div>
                <p class="p-title">价值观</p>
                <p class="p-text">乐观务实、</p>
                <p class="p-text">团结真诚、自律勇敢</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业荣誉 -->
      <div class="row corporate-reputation" v-show="focusIndex===2">
        <swiper class="reputation-swiper" :options="reputationOption">
          <swiper-slide
            class="swiper-slide business-introduction-swiper-slide"
            v-for="(item, index) in reputationList"
            :key="index"
          >
            <div class="reputation-img">
              <div class="reputation-content">
                <div>
                  <img :src="item.url" />
                </div>
                <P>{{item.text}}</P>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <!-- 联系我们 -->
      <div class="row corporate-reputation" v-show="focusIndex===3">
        <div class="as-content">
          <div class="as-img">
            <img
              src="https://file.lgbfss.com/www/official/images/about/as1.png"
              style="width:650px;"
            />
          </div>
          <div class="as-text">
            <div class="as-info">
              <img src="../../public/images/about/as2.jpg" />
              <p>电话：400-960-2015</p>
            </div>
            <div class="as-info">
              <img src="../../public/images/about/as3.jpg" />
              <p>邮编：710000</p>
            </div>
            <div class="as-info">
              <img src="../../public/images/about/as4.jpg" />
              <p>邮箱：lgbfss@foxmail.com</p>
            </div>
            <div class="as-info">
              <img src="../../public/images/about/as5.jpg" />
              <p>地址：陕西省西咸新区秦汉新城秦汉文创大厦5层</p>
            </div>
            <div class="as-form">
              <div style="display:flex;justify-content: space-between;">
                <input type="text" placeholder="姓名" />
                <input type="text" placeholder="邮箱" />
              </div>
              <div>
                <input type="text" placeholder="联系方式" />
              </div>
              <div>
                <textarea rows="3" cols="60" style="width:100%"></textarea>
              </div>
              <div>
                <button>提交</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 商务合作 -->
      <div class="row contact-us" v-show="focusIndex===4">
        <div class="contact-us-content">
          <div class="content-text">
            <P>从服务支持到安全保障，丰富而专业的运营经验帮助合作商打造人力资源和薪资核算解决方案，</P>
            <P>加入我们，让企业经营管理更简单！</P>
            <div>
              <p>业务合作</p>
              <p>13087507717</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="row cooperative-partner" v-show="focusIndex===5">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide
            class="swiper-slide business-introduction-swiper-slide"
            v-for="(item, index) in partnerList"
            :key="index"
          >
            <div class="swiperImg">
              <div>
                <img :src="item.url" />
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/footer";
import Nav from "../components/nav";
export default {
  data: () => {
    return {
      focusIndex: 0,
      scroll: '1',
      tabs: [
        {
          text: "公司简介",
        },
        {
          text: "企业文化",
        },
        {
          text: "企业信誉",
        },
        {
          text: "联系我们",
        },
        {
          text: "商务合作",
        },
        {
          text: "合作伙伴",
        },
      ],
      swiperOption: {
        slidesPerView: 3,
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 6000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      reputationOption: {
        slidesPerView: 2,
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 6000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      partnerList: [
        { url: require('.././../public/images/about/bank1.jpg') },
        { url: require('.././../public/images/about/bank2.jpg') },
        { url: require('.././../public/images/about/bank3.jpg') },
        { url: require('.././../public/images/about/bank4.jpg') },
      ],
      reputationList: [
        {
          url: require('../../public/images/about/zhi1.jpg'),
          text: "一、全球云端零工创客共享服务平台成功入选全国深化贸易创新发展试点“最佳实践案例”"
        },
        {
          url: require('../../public/images/about/zhi2.jpg'),
          text: "二、2020年1月，西安零工保信息技术有限公司荣获陕西省西咸新区秦汉新城管理委员会颁发的2019年度“优秀成长企业”"
        },
      ]
    };
  },
  components: {
    Footer,
    Nav,
  },
  created () {
  },
  watch: {
    $route () {
      this.focusIndex = this.$route.query.tab * 1
    }
  },
  mounted: function () {
    this.focusIndex = this.$route.query.tab * 1
    window.scrollTo(0, 0);
  },
  methods: {
    tabShow (index) {
      this.focusIndex = index
    },
    navTo (index) {
      this.$router.push({ path: "/about_us", query: { tab: index } });
    },
    dataInfo (data) {
      this.focusIndex = data
    }
  },
};
</script>

<style scoped>
.header {
  /* height: 100vh; */
  background-image: url("https://file.lgbfss.com/www/official/images/banner.jpg");
}
.thumb {
  margin-top: 30px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 5px;
  color: #515151;
  font-size: 13px;
}
.thumb > span {
  padding: 0 10px;
}
.tab-block {
  margin: 20px 0;
  justify-content: space-between !important;
  color: #515151;
}
.tab-block > div {
  width: 106px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #d5d5d5;
  position: relative;
  cursor: pointer;
}
.tab-block a {
  color: black;
}
.focus {
  background: #5fccff;
  color: #fff;
}
.focus a {
  color: #fff;
}
.focus:after {
  content: " ";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #5fccff;
  bottom: -5px;
  left: 48%;
  transform: rotate(45deg);
}
.company-profile div,
.corporate-culture div,
.corporate-reputation div,
.contact-us div,
.cooperative-partner div {
  flex-grow: 1;
  padding-bottom: 20px;
}
.company-profile,
.corporate-culture,
.contact-us {
  padding-top: 20px;
}
/* 布局 */
.row-title {
  display: flex;
}
.profile-text {
  margin-right: 20px;
}
.profile-text p {
  font-size: 18px;
  letter-spacing: 1px;
  text-indent: 2em;
  color: #333;
  line-height: 30px;
}
.profile-img {
  width: 610px;
  margin-top: 0px;
}
/* 企业文化 */
.list-item1 {
  background-color: #ffffff;
  margin: 6px;
  color: #333333;
  font-size: 20px;
  height: 314px;
  flex: 0%;
}
.cover-layer {
  width: 100%;
  height: 100%;
  background-color: #434343;
  opacity: 0.8;
  cursor: pointer;
  color: #ffffff;
}
.cover-layer .item-icon {
  width: 100px;
  height: 100px;
  margin: 0px auto;
  padding: 0px;
}
.cover-layer .p-title {
  letter-spacing: 0px;
  font-size: 32px;
  text-align: center;
}
.cover-layer .p-text {
  text-align: center;
  font-size: 18px;
}
.item-icon1 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon1.png)
    no-repeat center;
}
.item-icon2 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon2.png)
    no-repeat center;
}
.item-icon3 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon3.png)
    no-repeat center;
}
.cover-layer:hover .item-icon1 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon1-1.png)
    no-repeat center;
}
.cover-layer:hover .item-icon2 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon2-2.png)
    no-repeat center;
}
.cover-layer:hover .item-icon3 {
  background: url(https://file.lgbfss.com/www/official/images/about/cultureicon3-3.png)
    no-repeat center;
}
.cover-layer:hover {
  background-color: #a0dbf5;
  color: #3c4f5b;
}
/* 企业荣誉 */
.reputation-img .reputation-content {
  padding: 20px;
  width: 440px;
  margin: 0px auto;
  background: #cccccc;
  height: 460px;
}
.reputation-img .reputation-content p {
  letter-spacing: 1px;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}
/* 联系我们 */
.as-content {
  display: flex;
}
.as-img {
  margin-top: 70px;
}
.as-text {
  width: 530px;
  padding-top: 80px;
}
.as-text p {
  color: #666;
  font-size: 16px;
  margin-bottom: 10px;
}
.as-text .as-info img {
  margin-right: 5px;
  float: left;
  margin-top: 1px;
}
.as-text .as-form input,
textarea {
  width: 200px;
  padding: 10px 5px;
  border: none;
  border: 1px solid #e5e6e8;
}
.as-text .as-form button {
  margin: 0px auto;
  display: block;
  background-color: #396ce1;
  border-radius: 6px;
  border: none;
  padding: 8px 25px;
  color: #fff;
}
/* 商务合作 */
.contact-us-content {
  background: url(https://file.lgbfss.com/www/official/images/about/contactus.jpg)
    no-repeat;
  height: 450px;
}
.contact-us-content .content-text {
  width: 1000px;
  margin: 0px auto;
  padding: 100px 20px 20px;
}
.contact-us-content .content-text P {
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
  font-size: 20px;
  line-height: 40px;
}
.contact-us-content .content-text div {
  border: solid 1px #ffffff;
  width: 300px;
  margin: 0px auto;
  margin-top: 60px;
  border-radius: 5px;
  padding: 0px;
  cursor: pointer;
}
/* 合作伙伴 */
.swiper-button-prev {
  color: black;
  position: absolute;
  top: 42%;
  left: 0px;
}
.swiper-button-next {
  color: black;
  position: absolute;
  top: 42%;
  right: 0px;
}
.swiperImg {
  height: 400px;
  padding: 0px;
  padding-top: 50px;
  position: relative;
}
.swiperImg div {
  width: 290px;
  height: 150px;
  margin: 0px auto;
}
</style>